(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.GeomUndoStack = (function(superClass) {
    extend(GeomUndoStack, superClass);

    function GeomUndoStack(features) {
      this.push = bind(this.push, this);
      GeomUndoStack.include(L.Mixin.Events);
      this.elements = [];
      this.featuregroup = features;
    }

    GeomUndoStack.prototype.undo = function() {
      var prev;
      prev = this.pop();
      if (!prev) {
        return false;
      }
      this.featuregroup.clearLayers();
      if (prev != null ? prev.eachLayer : void 0) {
        prev.eachLayer((function(_this) {
          return function(l) {
            return _this.featuregroup.addLayer(l);
          };
        })(this));
        return this.fire('undo');
      }
    };

    GeomUndoStack.prototype.pop = function() {
      if (this.elements.length === 0) {
        return false;
      }
      return this.elements.pop();
    };

    GeomUndoStack.prototype.push = function() {
      var ref, state;
      if (((ref = this.featuregroup) != null ? ref.cloneGeom : void 0) != null) {
        state = this.featuregroup.cloneGeom();
        state.isInvalid = this.featuregroup.isInvalid;
        this.elements.push(state);
        return this.fire('push');
      }
    };

    GeomUndoStack.prototype.peek = function() {
      if (this.elements.length === 0) {
        return false;
      }
      return List.last(this.elements);
    };

    GeomUndoStack.prototype.getAt = function(i) {
      if (i < 0) {
        return this.getAt(this.elements.length + i);
      } else {
        if (this.elements[i] != null) {
          return this.elements[i];
        } else {
          return false;
        }
      }
    };

    GeomUndoStack.prototype.clearInvalidGeometryFromStack = function() {
      this.elements = List.filter(function(i) {
        return !((i.isInvalid != null) && i.isInvalid);
      }, this.elements);
      if ((this.featuregroup.isInvalid != null) && this.featuregroup.isInvalid) {
        this.undo();
      }
      return this.featuregroup.isInvalid = false;
    };

    return GeomUndoStack;

  })(L.Class);

}).call(this);
